/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_From_ParticipationInputs */

const en_remove_from_participation = /** @type {(inputs: Remove_From_ParticipationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from participation`)
};

const de_remove_from_participation = /** @type {(inputs: Remove_From_ParticipationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von Teilnahme entfernen`)
};

/**
* | output |
* | --- |
* | "Remove from participation" |
*
* @param {Remove_From_ParticipationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const remove_from_participation = /** @type {((inputs?: Remove_From_ParticipationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_From_ParticipationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_remove_from_participation(inputs)
	return en_remove_from_participation(inputs)
});